import React from "react"
import Logo from "../../images/logoSimple.inline.svg"
import * as styles from "./product-header.module.css"

export function ProductHeader(props: { title: string; color?: string }) {
  return (
    <h1 className={styles.productHeader}>
      <Logo className={styles.logo} />
      <span style={{ color: props.color }} className={styles.title}>
        {props.title}
      </span>
      {/* <sup style={{ color: props.color }} className={styles.tm}>
        TM
      </sup> */}
    </h1>
  )
}
